export default __webpack_public_path__ + "static/media/EM0350.34I-21991_-14991_0.041d5e1f.jpg";